/* global jQuery */

import { Module } from 'wrapper6'

export default class CheckoutShippingModal extends Module {
  ready () {
    const BODY = jQuery('body')
    if (BODY.hasClass('woocommerce-checkout') === false) {
      return
    }

    BODY.on('click', 'img.checkout-shipping-method-tooltip', this.handleShippingMethodTooltip.bind(this))
  }

  handleShippingMethodTooltip (e) {
    const tooltip = jQuery(e.currentTarget)

    let shippingMethodModal = jQuery('body .text-shipping-method-modal')

    shippingMethodModal.find('.shipping-method-title').html(tooltip.attr('data-title'))
    shippingMethodModal.find('.shipping-method-description').html(tooltip.attr('data-description'))

    window.openModal(shippingMethodModal.get(0))
  }
}
